/**
 * Sélection des photos de la séance Marina Fontaine (juillet 2023)
 * utilisées sur le site vitrine.
 *
 * 🎯 Pour changer une photo : remplace juste le nom de fichier ici.
 * Toutes les photos sont dans `public/images/marketing/`.
 *
 * ⚠️ Cohérence sémantique : chaque hero doit livrer instantanément
 * le sujet de sa page. Préférer un sujet bien cadré (visage visible
 * OU complètement hors champ — jamais coupé au menton).
 */

const BASE = '/images/marketing/';

/** Photo full-bleed du Hero accueil (background plein écran).
 *  Plan large du bar — barmaid de profil, étagères, suspensions. */
export const HERO_BG = `${BASE}0R9A2190.webp`;

/** Photos 4:5 portrait pour la section "Aperçus" cocktails (fallback
 *  si pas de top-rated en DB). 3 cocktails Marina avec garniture. */
export const APERCUS_PHOTOS: Array<{ src: string; alt: string }> = [
  { src: `${BASE}0R9A2221.webp`, alt: 'Cocktail signature à la fraise et menthe' },
  { src: `${BASE}0R9A1478.webp`, alt: 'Cocktail rouge en terrasse' },
  { src: `${BASE}0R9A2017.webp`, alt: 'Trinquage entre amis au bar' },
];

/** Photos 4:5 portrait pour la mosaïque de la section "Visite".
 *  4 photos staggered. Mix client + équipe + ambiance pour la chaleur humaine. */
export const VISITE_PHOTOS: Array<{ src: string; alt: string }> = [
  { src: `${BASE}0R9A1755.webp`, alt: 'Barmaid au shaker derrière le bar' },
  { src: `${BASE}0R9A1878.webp`, alt: 'Serveuse avec plateau de bières' },
  { src: `${BASE}0R9A1613.webp`, alt: 'Terrasse ensoleillée entre amis' },
  { src: `${BASE}0R9A2156.webp`, alt: "L'équipe du Bar L'Alambic" },
];

/** Photos pour la page /reserver.
 *  Hero : 3 amis souriants en terrasse (chaleureux).
 *  Cards : fond contextualisé pour chaque type de réservation. */
export const RESERVER_HERO = `${BASE}0R9A1543.webp`;
export const RESERVER_TABLE_BG = `${BASE}0R9A1755.webp`;
export const RESERVER_SALLE_BG = `${BASE}0R9A1717.webp`;

/** Bandeaux hero des onglets publics.
 *  Chaque hero est choisi pour évoquer immédiatement le contenu de la page. */
export const MENU_HERO = `${BASE}0R9A2050.webp`;        // plateau charcuterie/fromages présenté
export const COCKTAILS_HERO = `${BASE}0R9A2221.webp`;   // cocktail signature gros plan
export const DEGUSTATION_HERO = `${BASE}0R9A1988.webp`; // bartender présente Glenfarclas 25 ans
// ⚠️ TODO : photo dédiée VIN à fournir (bouteilles + verres / cave / sommelier).
// En attendant, sangria rosée en verre à vin = placeholder honnête (vin techniquement).
export const VINS_HERO = `${BASE}0R9A1895.webp`;
export const EVENTS_HERO = `${BASE}0R9A1665.webp`;      // partie de crible en cours

/** Photo de l'équipe — disponible pour usage futur (À propos, footer, etc.) */
export const TEAM_PHOTO = `${BASE}0R9A2156.webp`;

/**
 * Cadrage CSS recommandé par photo hero.
 * `object-position` à passer en prop au composant <PublicPageHero>.
 *
 * Calibration faite après visualisation manuelle des photos en aspect 16:9
 * (le `PublicPageHero` les rend en h-[400px..500px] paysage).
 *
 * Convention : 'center N%' où N=0 montre le haut, N=100 montre le bas.
 * Pour les photos portrait avec sujet centré, viser N=40-50%.
 */
export const HERO_OBJECT_POSITION: Record<string, string> = {
  [MENU_HERO]: 'center 60%',        // plateau au centre-bas — éviter de couper la nourriture
  [COCKTAILS_HERO]: 'center 35%',   // cocktail au tiers haut — verre + garniture visibles
  [DEGUSTATION_HERO]: 'center 45%', // bouteille Glenfarclas centrée — éviter de couper l'étiquette
  [VINS_HERO]: 'center 55%',        // sangria + table — garder le verre dans le cadre
  [EVENTS_HERO]: 'center 50%',      // planche de crible au centre
};
